import Flex from '@Components/Bases/Flex';
import { Step, StepLabel, Stepper, Typography } from '@mui/material';
import { stepsPublishReportCVUP } from './utils';

const Steppers = () => {
  return (
    <Flex
      px={{ xs: 2, sm: 4 }}
      borderRadius={1}
      py={2}
      bgcolor={'white'}
      flexDirection="column"
    >
      <Typography fontWeight={'bold'}>
        ขั้นตอนการจัดทำและเผยแพร่แบบแสดงรายงาน Corporate Value Up
      </Typography>
      <Stepper
        alternativeLabel
        activeStep={4}
        connector={null}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        {stepsPublishReportCVUP.map((step, index) => (
          <Step key={index}>
            <StepLabel
              StepIconComponent={() => (
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  textAlign="center"
                  mt={1}
                  width={{ xs: 24, sm: 32 }}
                  height={{ xs: 24, sm: 32 }}
                  borderRadius={'50%'}
                  bgcolor={'primary.main'}
                >
                  {step.number}
                </Typography>
              )}
            >
              <Typography align="center" variant="subtitle2">
                {step.label}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Flex>
  );
};

export default Steppers;
